(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["stockist-directory"] && !Shopify.designMode) return;
  try {
    
function initialiseStockistDirectories(root) {
  root.querySelectorAll('[data-stockist-directory]').forEach(directory => {
    if (directory.dataset.initialised) return;
    directory.dataset.initialised = 'true';
    const input = directory.querySelector('[data-stockist-search]');
    const rows = [...directory.querySelectorAll('[data-stockist-row]')];
    const count = directory.querySelector('[data-stockist-count]');
    const empty = directory.querySelector('[data-stockist-empty]');
    const normalise = text => text.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    const filterRows = () => {
      const terms = normalise(input.value).split(' ').filter(Boolean);
      let visible = 0;
      rows.forEach(row => {
        const text = normalise(row.dataset.search);
        row.hidden = !terms.every(term => text.includes(term));
        if (!row.hidden) visible += 1;
      });
      count.textContent = count.dataset.resultsLabel.replace('__COUNT__', String(visible));
      empty.hidden = visible > 0;
    };
    input.addEventListener('input', filterRows);
    filterRows();
  });
}
initialiseStockistDirectories(document);
document.addEventListener('shopify:section:load', event => initialiseStockistDirectories(event.target));

  } catch(e) { console.error(e); }
})();
})();
